import IBAN from 'iban'

export default (value, args) => {
  return IBAN.isValid(value)
}
